import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchRegionDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'region/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveRegion(app, dataToSave) {
  const { tenant, user = {}, data } = dataToSave;
  const regionData = {
    tenant: tenant.id,
    doc_type: DocType.REGION,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    description: !data.description ? null : util.toStringText(data.description),
    system_defined: util.toBoolean(data.system_defined),
  };
  return common.saveDoc(app, {
    source: data,
    doc: regionData,
    user,
  });
}

export function deleteRegion(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.REGION
  });
}

export function fetchRegionById(app, params) {
  const { id } = params;
  const docType = DocType.REGION;
  return common.getDoc(app, { id, docType });
}